export * from './doctor-quick-prescription.service';